var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isVisible)?_c('b-button',{staticClass:"goTop",on:{"click":_vm.backToTop}},[_c('fa',{attrs:{"icon":"angle-up","aria-hidden":"true"}}),_vm._v(" 맨 위로 이동 ")],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }